module.exports = __webpack_public_path__ + "static/img/14000791.0ea8e8a4.png";